import { BetStatusWatcher } from '../../../logger/BetStatusWatcher';
import { RoundIntegrityWatcher, RoundIntegrityWatcherPhases } from '../../../logger/RoundIntegrityWatcher';
import { betActions } from '../../../store/slices/bets/slice';
import { gameStateActions } from '../../../store/slices/game/slice';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface GameMessage extends GameCommunicationMessageType {
  id?: string;
}

export class CoreGameGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Game;

  public process(message: GameMessage): void {
    const gameId = this.store.getState().gameState.gameId;
    const newGameId = message.id;

    if (newGameId && gameId !== newGameId) {
      RoundIntegrityWatcher.setPhase(RoundIntegrityWatcherPhases.Game);
      BetStatusWatcher.logState();

      this.store.dispatch(gameStateActions.setGameId(newGameId));
      this.store.dispatch(betActions.resetBetStack());
      this.store.dispatch(gameStateActions.resetForNewGame());
    }
  }
}
